import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9fe844a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__title padding-modal" }
const _hoisted_2 = { class: "padding-modal" }
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = {
  key: 0,
  class: "modal__action top-space"
}
const _hoisted_5 = {
  key: 1,
  class: "absolute top-0 right-0 pt-4 pr-4"
}

import { computed, defineComponent, useSlots } from 'vue';
import { Icon } from '@iconify/vue';
type ModalStyle = 'confirm';
interface Props {
  confirmText?: string | boolean;
  cancelText?: string | boolean;
  buttonsDisabled?: boolean;
  modalStyle?: ModalStyle;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    confirmText: { type: [String, Boolean], default: 'Confirm' },
    cancelText: { type: [String, Boolean], default: 'Cancel' },
    buttonsDisabled: { type: Boolean },
    modalStyle: { default: undefined }
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any) {

const props = __props as { confirmText: string | boolean, cancelText: string | boolean, buttonsDisabled?: boolean, modalStyle: ModalStyle }

defineComponent({
  name: 'BaseModal',
  inheritAttrs: false,
});
const slots = useSlots();


const isConfirmModal = computed(() => props.modalStyle === 'confirm');
const hasTitle = computed(() => !!slots.title);

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, _mergeProps(_ctx.$attrs, {
    classes: "modal-container",
    "content-class": "modal-content"
  }), {
    default: _withCtx(({ params, close }) => [
      (_unref(hasTitle))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["modal__top flex justify-between items-center mb-2", { 'border-b': _unref(hasTitle) }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "title")
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", { params: params })
        ]),
        (_unref(isConfirmModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (__props.cancelText)
                ? (_openBlock(), _createBlock(_component_BaseButton, {
                    key: 0,
                    disabled: __props.buttonsDisabled,
                    "color-scheme": "primary",
                    secondary: "",
                    onClick: close,
                    class: "px-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.cancelText), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (__props.confirmText)
                ? (_openBlock(), _createBlock(_component_BaseButton, {
                    key: 1,
                    disabled: __props.buttonsDisabled,
                    "color-scheme": "primary",
                    onClick: ($event: any) => (_ctx.$emit('confirm', close)),
                    class: "px-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.confirmText), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(hasTitle))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_BaseButton, {
              class: "close-btn",
              secondary: "",
              height: "36px",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Icon), {
                  icon: "akar-icons:cross",
                  class: "w-4 h-4"
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16))
}
}

})